<div class="card">
  <div class="card-body">
    {{ data.id }}
  </div>
</div>
